import { useState } from "react";
import { IconButton, Popover, Typography, Box } from "@mui/material";
// import FunctionsIcon from '@mui/icons-material/Functions';
import CalculateIcon from "@mui/icons-material/Calculate";

const FormulaBrokerage = ({ final_weight, broker, brokerageRate=0, miller }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "formula-popover" : undefined;

  const calcBrokerageMiller = final_weight * brokerageRate; // Calculate the discount amount
  const calcBrokerageBroker = final_weight * brokerageRate; // Calculate the discount amount

  return (
    <>
      {broker
        ? `₹ ${Number(calcBrokerageBroker).toFixed(2)}/-`
        : miller
        ? `₹ ${Number(calcBrokerageMiller).toFixed(2)}/-`
        : ""}
      <IconButton
        size="small"
        onClick={handleOpen}
        sx={{ padding: "0 0 0 4px" }}
      >
        <CalculateIcon fontSize="inherit" />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box sx={{ p: 2 }}>
          <Typography variant="body2">
            <strong>Brokerage Amount Formula:</strong>
            <br />
            <br />
            {broker ? (
              ""
            ) : (
              <>
                <strong> For Miller</strong> <br /> = Final Weight × Brokerage Rate
                <br /> = {final_weight} × {brokerageRate}
                <br />
                <strong> </strong> = ₹{Number(calcBrokerageMiller).toFixed(2)}
                <br />
              </>
            )}
            {miller ? (
              ""
            ) : (
              {/* <>
                <strong> For Broker</strong> <br /> = Final Weight × 50
                <br /> = {final_weight} × 50
                <br />
                <strong> </strong> = ₹{Number(calcBrokerageBroker).toFixed(0)}
              </> */}
            )}
          </Typography>
        </Box>
      </Popover>
    </>
  );
};

export default FormulaBrokerage;
